/*
 * Banner havolasi yordamchilari.
 *
 * ZOD'SIZ alohida fayl: Mini App faqat shuni import qiladi (`@aps/contracts/banner-link`).
 * Umumiy barrel'dan import butun zod kutubxonasini (~27 KB gzip) Mini App bundleiga
 * tortardi (`money-format` bilan bir xil qoida).
 */
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const BANNER_SEARCH_MAX = 100;
/** Noto'g'ri qator uchun `null` — hech qachon yiqilmaydi. */
export function parseBannerLink(value) {
    if (value === null || value === undefined)
        return null;
    const raw = value.trim();
    if (raw === 'catalog')
        return { type: 'catalog' };
    const colon = raw.indexOf(':');
    if (colon < 1)
        return null;
    const kind = raw.slice(0, colon);
    const rest = raw.slice(colon + 1);
    if (kind === 'product') {
        return SLUG_PATTERN.test(rest) && rest.length <= 120 ? { type: 'product', slug: rest } : null;
    }
    if (kind === 'category') {
        return UUID_PATTERN.test(rest) ? { type: 'category', categoryId: rest } : null;
    }
    if (kind === 'search') {
        const query = rest.trim();
        // Boshqaruv belgilari (yangi qator va h.k.) qidiruv matniga kirmaydi.
        const hasControl = query.split('').some((char) => char.charCodeAt(0) < 32);
        return query.length > 0 && query.length <= BANNER_SEARCH_MAX && !hasControl
            ? { type: 'search', query }
            : null;
    }
    return null;
}
export function formatBannerLink(link) {
    switch (link.type) {
        case 'catalog':
            return 'catalog';
        case 'product':
            return `product:${link.slug}`;
        case 'category':
            return `category:${link.categoryId}`;
        case 'search':
            return `search:${link.query.trim()}`;
        default: {
            const exhaustive = link;
            return exhaustive;
        }
    }
}
//# sourceMappingURL=banner-link.js.map